// extracted by mini-css-extract-plugin
export default {"Loader":"Loading_Loader__r62FW","Loader__circle":"Loading_Loader__circle__yoLk4","spinner":"Loading_spinner__PNFwi"};